// reducers/index.js
import { combineReducers } from "redux";
import account from "./account";
import user from "./user";
import misc from "./misc";
import orders from "./orders";

const rootReducer = combineReducers({
  // Add your reducers here
  account,
  orders,
  user,
  misc,
});

export default rootReducer;
